import { Button, Card, CardBody, CardHeader, Col, Dropdown, DropdownToggle, Row, Spinner } from "react-bootstrap";
import { MdOutlineOilBarrel, MdOutlineSolarPower, MdQuestionMark } from "react-icons/md";
import { SlEnergy } from "react-icons/sl";
import { TbFlame } from "react-icons/tb";
import CommonUtils from "../../utils/common";
import EnergoSwitch from "../shared/EnergoSwitch";
import EnergoTooltip from "../shared/EnergoTooltip";
import { useAuthState } from "../../context/AuthContext";
import { BsGearFill } from "react-icons/bs";
import { TiThMenu } from "react-icons/ti";
import { useState } from "react";
import EnergoCircleIcon from "../shared/EnergoCircleIcon";

const DetailedAnlageActionCard = ({owner, anlage, elvs, ticket, switchHandler, cancelHandler, changeHandler, transparent, history}) => {

    const UTILS = new CommonUtils();

    const [mouseEntered, setMouseEntered] = useState(false);
    var schema = "secondary";
    var color = "dark";
    const iconSize = 30;
    var icon = <MdQuestionMark size={iconSize} />
    var hasSecondZaehler = false;
    var switchToggle = false;
    var elv = null;

    if (anlage) {
        if (anlage.x_studio_field_3eKe0 === "Strom") { schema= "energo"; color= "light"; icon= <SlEnergy size={iconSize} />; }
        if (anlage.x_studio_field_3eKe0 === "Gas") { schema= "info"; color= "light"; icon= <TbFlame size={iconSize} />; }
        if (anlage.x_studio_field_3eKe0 === "Oil") { schema= "danger"; color= "light"; icon= <MdOutlineOilBarrel size={iconSize} />; }
        if (anlage.x_studio_field_3eKe0 === "Strom-Einspeisung") { schema= "warning"; color= "light"; icon= <MdOutlineSolarPower size={iconSize} />; }
        if (anlage.x_zaehlpunktnummer_02 !== "" && anlage.x_zaehlpunktnummer_02 !== "False" && anlage.x_zaehlpunktnummer_02 !== false) hasSecondZaehler= true;
        if (history) { schema="secondary"; color="dark"; }
    }

    if (elvs) {
        var filteredElvs  = elvs.filter(e => anlage.x_elv_ids.length > 0 && anlage.x_elv_ids.includes(e.id) && e.x_kunde_id !== undefined && e.x_kunde_id[0] === owner);
        if (history) {
                console.log(filteredElvs);
            }
        if (filteredElvs && filteredElvs.length > 0) {
            elv = filteredElvs.filter(f => f.x_datum_vertragsende === "False" || new Date(f.x_datum_vertragsende) > new Date())[0];
            
            if (elv !== undefined && elv.x_kunde_id[0] === owner) switchToggle = true;
        }
    }


    const onSwitchHandler = () => {
        if (switchHandler) switchHandler(anlage)
    }

    // if loading
    if (!anlage) return <Spinner className="text-energo" animation="grow" />

    return (
        <Card 
            className={`mt-3 border-${schema} ${mouseEntered && 'shadow-lg'}`} 
            style={{borderRadius: 20, overflow: "hidden", border: "4px solid"}}
            onMouseEnter={() => setMouseEntered(true)}
            onMouseLeave={() => setMouseEntered(false)}
        >
            <CardHeader className={`bg-${schema} text-${color} ${transparent? 'transparent': ''}`}>
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-3">
                        <EnergoCircleIcon icon={icon} />
                        <span className="hide-on-small" style={{fontSize: 25}}>{anlage.x_studio_field_3eKe0}</span>
                    </div>
                    <span className="hide-on-medium-and-big" style={{fontSize: 30, fontWeight: 300}}>{anlage.x_studio_field_mWMGR}</span>
                    <div className="d-flex align-items-center gap-2">
                        <small className="hide-on-medium-and-small">Anlagennummer ENERGO:</small>
                        <small className="hide-on-small" style={{ fontSize: 30, fontWeight: 300 }}>{anlage.x_studio_field_mWMGR}</small>
                        {changeHandler &&
                            <>
                                <button className="btn btn-link text-white" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                    <TiThMenu className="text-warning" size={30} />
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    <li key={`anlage-edit-btn-${anlage.id}`} className="text-center">
                                        <a onClick={e => {e.preventDefault(); changeHandler(anlage)}} href="/anlage/ändern" className="link-energo text-dark">Ändern / Frage</a>
                                    </li>
                                </ul>
                            </>
                        }
                    </div>
                </div>
            </CardHeader>
            <CardBody className={`${transparent? 'transparent': ''}`}>
                <Row>
                    <Col xs="12" md="7" xl="8" className="order-2 order-md-1">
                        <p>{anlage.id}</p>
                        <p>Energieform &nbsp; <small className="text-muted">{anlage.x_studio_field_3eKe0}</small></p>
                        <p>Anlagenadresse &nbsp; <small className="text-muted">{anlage.x_adresse_kompakt}</small></p>
                        {UTILS.notOdooFalseOrEmpty(anlage.x_anlagenverwendung) || UTILS.notOdooFalseOrEmpty(anlage.x_anlagenverwendung_detail) ?
                            <p>
                                Anlagenverwendung &nbsp; 
                                <small className="text-muted">
                                    {
                                        UTILS.notOdooFalseOrEmpty(anlage.x_anlagenverwendung_detail)? anlage.x_anlagenverwendung_detail : 
                                        UTILS.notOdooFalseOrEmpty(anlage.x_anlagenverwendung)? anlage.x_anlagenverwendung : ""
                                    }
                                </small>
                            </p> :
                            null
                        }
                        <p>Anlagennummer ENERGO &nbsp; <small className="text-muted">{anlage.x_studio_field_mWMGR}</small></p>
                    </Col>
                    {switchHandler &&
                        <Col xs="12" md="5" xl="4" className="order-1 order-md-2">
                            <div className="d-flex justify-content-center align-items-center h-100 flex-column gap-2">

                                <div hidden={history}>
                                    {ticket && ticket.length > 0 ? 
                                        ticket[0].ticket_type_id[0] === 15 ? 'Anmeldung im Gange' :
                                        ticket[0].ticket_type_id[0] === 16 ? 'Abmeldung im Gange' :
                                        ticket[0].ticket_type_id[0] === 17 ? 'Anlage wird hinzugefügt' :
                                        null : 
                                        switchToggle === true?
                                            'Anlage angemeldet' :
                                            'Anlag abgemeldet'
                                    }
                                </div>
                                <div hidden={history}>
                                    {ticket && ticket.length > 0 ?
                                        <>
                                            <div className="d-flex align-items-center gap-2">
                                                <BsGearFill size={40} className={`text-${schema} rotating`} />
                                                <EnergoTooltip tKey={ticket[0] === 16? "2003":"2002"} position="right" />
                                            </div>
                                            {cancelHandler &&
                                                <Button style={{borderRadius: 15, paddingLeft: 15, paddingRight: 15}} size="sm" variant="danger" onClick={() => cancelHandler(ticket[0].id)}>Abbrechen</Button>
                                            }
                                        </>:
                                        <div className="d-flex align-items-center gap-2">
                                            <EnergoSwitch schema={schema} defaultChecked={switchToggle} handler={onSwitchHandler} id={`switch-${anlage.id}`} />
                                            <EnergoTooltip tKey="2001" position="right" />
                                        </div>
                                    }
                                </div>

                                {switchToggle === true &&
                                    <a href={`/dashboard/energieliefervertraege/${elv.id}`} className={`link-energo text-${schema}`}>Energieliefervertrag ansehen</a>
                                }
                            </div>
                        </Col>
                    }
                </Row>
                <Row>
                    <Col className={`${hasSecondZaehler? 'border-right mt-3': ''}`}>
                        {hasSecondZaehler && <p className="text-center">Zählpunkt 1</p>}
                        <p>Zählernummer &nbsp; <small className="text-muted">{anlage.x_zaehlernummer_01}</small></p>
                        <p>Zählpunktnummer &nbsp; <small className="text-muted">{anlage.x_zaehlpunktnummer_01}</small></p>
                        {UTILS.notOdooFalseOrEmpty(anlage.x_lastprofil_01) &&
                            <p>Lastprofil &nbsp; <small className="text-muted">{anlage.x_lastprofil_01}</small></p>
                        }
                        <p>Smartmeter &nbsp; <small className="text-muted">{UTILS.checkUncheckIcons(anlage.x_is_smartmeter_01)}</small></p>
                    </Col>
                    <Col hidden={!hasSecondZaehler}>
                        <p className='text-center mt-3'>Zählpunkt 2</p>
                        <p>Zählernummer &nbsp; <small className="text-muted">{anlage.x_zaehlernummer_02}</small></p>
                        <p>Zählpunktnummer &nbsp; <small className="text-muted">{anlage.x_zaehlpunktnummer_02}</small></p>
                        {UTILS.notOdooFalseOrEmpty(anlage.x_lastprofil_02) &&
                            <p>Lastprofil &nbsp; <small className="text-muted">{anlage.x_lastprofil_02}</small></p>
                        }
                        <p>Smartmeter &nbsp; <small className="text-muted">{UTILS.checkUncheckIcons(anlage.x_is_smartmeter_02)}</small></p>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}
export default DetailedAnlageActionCard;